import { https } from "./http";
import * as types from '../../mutation_types';

const state = {
    page:1,
    currentpage:5,
    search:'',
    loading:false,
    matnr:'',
    date_from:'',
    date_to:'',
    data:{}
};
const getters = {
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    search:state=>state.search,
    loading:state=>state.loading,
    matnr:state=>state.matnr,
    date_from:state=>state.date_from,
    date_to:state=>state.date_to,
    data:state=>state.data
};
const actions = {
    async fetchPurchaseDraftHeaders({commit}){
        let uri = `purchase-return-draft-header?page=${state.page}&currentpage=${state.currentpage}&search=${state.search}&matnr=${state.matnr}&date_from=${state.date_from}&date_to=${state.date_to}`;
        await https().get(uri).then(response=>{
            commit(types.PURCHASE_RETURN_DRAFT_DATA,response.data);
        }).catch(error=>{
            console.log(error);
        })
    }
};
const mutations = {
    [types.PURCHASE_RETURN_DRAFT_PAGE](state,data){
        state.page = data;
    },
    [types.PURCHASE_RETURN_DRAFT_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.PURCHASE_RETURN_DRAFT_SEARCH](state,data){
        state.search = data;
    },
    [types.PURCHASE_RETURN_DRAFT_LOADING](state){
        state.loading = !state.loading;
    },
    [types.PURCHASE_RETURN_DRAFT_MATNR](state,data){
        state.matnr = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DATE_FROM](state,data){
        state.date_from = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DATE_TO](state,data){
        state.date_to = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DATA](state,data){
        state.data = data;
    }
};
export {
    state,getters,actions,mutations
}